import PropTypes from 'prop-types'

export const PROP_TYPES = {
  externalURL: PropTypes.string,
  primaryAction: PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.func,
    props: PropTypes.shape({}),
    containerProps: PropTypes.shape({}),
    fullWidth: PropTypes.bool,
  }),
  secondaryAction: PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.func,
    isLoading: PropTypes.bool,
    props: PropTypes.shape({}),
    containerProps: PropTypes.shape({}),
  }),
  tertiaryAction: PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.func,
    icon: PropTypes.object,
  }),
}
